export const dashboardInitialState = {
  NBJobs: [],
  EPR: [],
  PPR: [],
  refresh: false,
};
